/* Actions that are of 'global' interest */
/* Keeping them out of the duck because of code splitting */

// Authentication
export const LOGIN_START = '@komigen/mobile-frontend/authentication/LOGIN_START';
export const LOGIN_FAIL = '@komigen/mobile-frontend/authentication/LOGIN_FAIL';
export const REGISTER_FAIL = '@komigen/mobile-frontend/authentication/REGISTER_FAIL';
export const LOGIN_SUCCESS = '@komigen/mobile-frontend/authentication/LOGIN_SUCCESS';
export const LOGIN_COMPLETE = '@komigen/mobile-frontend/authentication/LOGIN_COMPLETE';
export const LOGOUT_START = '@komigen/mobile-frontend/authentication/LOGOUT_START';
export const LOGOUT = '@komigen/mobile-frontend/authentication/LOGOUT';
export const ERROR_OCCURRED_DURING_LOGOUT = '@komigen/mobile-frontend/authentication/ERROR_OCCURRED_DURING_LOGOUT';
export const AUTHENTICATION_COMPLETE = '@komigen/mobile-frontend/authentication/AUTHENTICATION_COMPLETE';
export const REGISTRATION_DETAIL_COMPLETE = '@komigen/mobile-frontend/authentication/REGISTRATION_DETAIL_COMPLETE';
export const SESSION_UPDATED = '@komigen/mobile-frontend/authentication/SESSION_UPDATED';
export const SESSION_VALID = '@komigen/mobile-frontend/authentication/SESSION_VALID';

// Analytics
export const UPDATE_FRAME = '@komigen/mobile-frontend/analytics/UPDATE_FRAME';

// Payment
export const GENERAL_ERROR = '@komigen/mobile-frontend/payment/GENERAL_ERROR';
export const SELECT_PAYMENT_METHOD = '@komigen/mobile-frontend/payment/SELECT_PAYMENT_METHOD';
export const CLEAR_ALL = '@komigen/mobile-frontend/payment/CLEAR_ALL';
export const CLEAR_ALL_PW = '@komigen/mobile-frontend/payment/CLEAR_ALL_PW';
export const PROMPT_SECUREID = '@komigen/mobile-frontend/payment/PROMPT_SECUREID';
export const SHOP_ITEM_FOR_DEPOSIT = '@komigen/mobile-frontend/payment/SHOP_ITEM_FOR_DEPOSIT';
export const HYDRATED_DETAILS = '@komigen/mobile-frontend/payment/HYDRATED_DETAILS';
export const UPDATE_PAYMENT_METHODS = '@komigen/mobile-frontend/payment/UPDATE_PAYMENT_METHODS';
export const INIT_SPEC = '@komigen/mobile-frontend/payment/INIT_SPEC';
export const UPDATE_FEES_AND_LIMITS = '@komigen/mobile-frontend/payment/UPDATE_FEES_AND_LIMITS';
export const VALIDATE_SPEC = '@komigen/mobile-frontend/payment/VALIDATE_SPEC';
export const UPDATE_AUTOSKIP = '@komigen/mobile-frontend/payment/UPDATE_AUTOSKIP';
export const UPDATE_AMOUNT = '@komigen/mobile-frontend/payment/UPDATE_AMOUNT';
export const SELECT_DEFAULT_AMOUNT = '@komigen/mobile-frontend/payment/SELECT_DEFAULT_AMOUNT';
export const SHOW_DEPOSIT_LIMIT_OPTION = '@komigen/mobile-frontend/payment/SHOW_DEPOSIT_LIMIT_OPTION';
export const UPDATE_SPEC = '@komigen/mobile-frontend/payment/UPDATE_SPEC';
export const PROMPT_KYC = '@komigen/mobile-frontend/payment/PROMPT_KYC';
export const EXECUTE_DEPOSIT_PRECHECK = '@komigen/mobile-frontend/payment/EXECUTE_DEPOSIT_PRECHECK';
export const GET_PAYMENTS_TAGS = '@komigen/mobile-frontend/payment/GET_PAYMENTS_TAGS';
export const EXECUTE_DEPOSIT = '@komigen/mobile-frontend/payment/EXECUTE_DEPOSIT';
export const CLEAR_RESULT = '@komigen/mobile-frontend/payment/CLEAR_RESULT';
